import _TextareaAutosize from '@mui/material/TextareaAutosize';

export default _TextareaAutosize;                 // default import works
export const TextareaAutosize = _TextareaAutosize; // named import also works